import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { PortainerGroup } from '../types';

import { portainerKeys } from './query-keys';

export async function getPortainerGroups(): Promise<PortainerGroup[]> {
  return mediaManagerClient.get('/api/v1/portainer/groups').then(({ data }) => data);
}

type QueryFnType = typeof getPortainerGroups;

interface UsePortainerGroupsParams {
  config?: QueryConfig<QueryFnType>;
}

export function usePortainerGroups({ config = {} }: UsePortainerGroupsParams = {}) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: portainerKeys.groups(),
    queryFn() {
      return getPortainerGroups();
    },
  });
}
